import { CHAINS } from '../config/chains';

/** Stellar explorers expect 64 hex chars without an EVM-style `0x` prefix. */
function stellarTxHashForExplorerUrl(txHash) {
    const t = String(txHash || '').trim();
    if (t.startsWith('0x') || t.startsWith('0X')) {
        return t.slice(2).toLowerCase();
    }
    return t;
}

/**
 * Get the block explorer URL for a transaction hash on a given chain
 * @param {string|number} chainId - The chain ID (decimal, hex, or config id e.g. "stellar")
 * @param {string} txHash - The transaction hash
 * @returns {string|null} - The explorer URL or null if chain not found
 */
export const getExplorerTxUrl = (chainId, txHash) => {
    if (!chainId || !txHash) return null;

    const chain = Object.values(CHAINS).find((c) => {
        if (typeof chainId === 'string' && c.id === chainId) {
            return true;
        }
        if (typeof chainId === 'number' && c.chainIdDecimal === chainId) {
            return true;
        }
        if (typeof chainId === 'string') {
            const chainIdNum = chainId.startsWith('0x') ? parseInt(chainId, 16) : parseInt(chainId, 10);
            if (!Number.isNaN(chainIdNum)) {
                return c.chainIdDecimal === chainIdNum;
            }
        }
        return false;
    });

    if (!chain || !chain.blockExplorerUrl) {
        return null;
    }

    const explorerUrl = chain.blockExplorerUrl.replace(/\/$/, '');
    const pathHash = chain.id === 'stellar' ? stellarTxHashForExplorerUrl(txHash) : txHash;
    return `${explorerUrl}/tx/${pathHash}`;
};

/**
 * Explorer URL from UI token `chainId` (config key, e.g. "stellar") and CHAINS entry.
 * Uses chain key when present so Stellar (chainIdDecimal 0) is not skipped by truthy checks on 0.
 */
export const getExplorerTxUrlFromTokenChain = (chainKey, chainConfig, txHash) => {
    if (!txHash) return null;
    const ref =
        chainKey != null && chainKey !== ''
            ? chainKey
            : chainConfig && chainConfig.chainIdDecimal !== undefined && chainConfig.chainIdDecimal !== null
              ? chainConfig.chainIdDecimal
              : null;
    if (ref === null || ref === '') return null;
    return getExplorerTxUrl(ref, txHash);
};
